export default {
  statuses: [],
  aboServices: []
};
